/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ invitedBy: NonNullable<unknown>, org: NonNullable<unknown>, url: NonNullable<unknown> }} Email_Invite_BodyInputs */

const th_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} ได้เชิญคุณเข้าร่วม ${i?.org} บน Remy Sport

ตอบรับคำเชิญ: ${i?.url}

หากคุณไม่ได้คาดหวังอีเมลฉบับนี้ คุณสามารถเพิกเฉยได้`)
};

const en_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} has invited you to join ${i?.org} on Remy Sport.

Accept the invitation: ${i?.url}

If you were not expecting this, you can ignore this email.`)
};

const ja_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy}さんが、Remy Sport の${i?.org}にあなたを招待しました。

招待を承認する: ${i?.url}

お心当たりがない場合は、このメールは破棄してください。`)
};

const zh_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} 邀请你加入 Remy Sport 上的 ${i?.org}。

接受邀请：${i?.url}

如果你并未预料到这封邮件，忽略即可。`)
};

const es_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} te ha invitado a unirte a ${i?.org} en Remy Sport.

Acepta la invitación: ${i?.url}

Si no esperabas esto, puedes ignorar este correo.`)
};

const pt_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} convidou você para entrar em ${i?.org} no Remy Sport.

Aceite o convite: ${i?.url}

Se você não esperava isso, pode ignorar este e-mail.`)
};

const id_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} mengundang Anda bergabung dengan ${i?.org} di Remy Sport.

Terima undangan: ${i?.url}

Jika Anda tidak menduganya, abaikan saja email ini.`)
};

const fr_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} vous a invité à rejoindre ${i?.org} sur Remy Sport.

Accepter l’invitation : ${i?.url}

Si vous ne vous y attendiez pas, ignorez cet e-mail.`)
};

const tl_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inanyayahan ka ni ${i?.invitedBy} na sumali sa ${i?.org} sa Remy Sport.

Tanggapin ang paanyaya: ${i?.url}

Kung hindi mo ito inaasahan, huwag na lang pansinin ang email na ito.`)
};

const vi_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} mời bạn tham gia ${i?.org} trên Remy Sport.

Nhận lời mời: ${i?.url}

Nếu bạn không chờ thư này, cứ bỏ qua nó.`)
};

const ko_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy}님이 Remy Sport의 ${i?.org}에 초대했습니다.

초대 수락: ${i?.url}

예상하지 못한 메일이라면 무시하셔도 됩니다.`)
};

const de_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} hat dich eingeladen, ${i?.org} auf Remy Sport beizutreten.

Einladung annehmen: ${i?.url}

Wenn du damit nicht gerechnet hast, ignoriere diese E-Mail einfach.`)
};

const ru_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} приглашает вас в ${i?.org} на Remy Sport.

Принять приглашение: ${i?.url}

Если вы этого не ждали, просто не отвечайте на это письмо.`)
};

const tr_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy}, sizi Remy Sport'ta ${i?.org} kuruluşuna davet etti.

Daveti kabul edin: ${i?.url}

Beklemiyorduysanız bu e-postayı yok sayın.`)
};

const it_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} ti ha invitato a unirti a ${i?.org} su Remy Sport.

Accetta l'invito: ${i?.url}

Se non te lo aspettavi, ignora pure questo messaggio.`)
};

const pl_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} zaprasza cię do ${i?.org} w Remy Sport.

Przyjmij zaproszenie: ${i?.url}

Jeśli się tego nie spodziewałeś, po prostu zignoruj tę wiadomość.`)
};

const uk_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} запрошує вас до ${i?.org} на Remy Sport.

Прийняти запрошення: ${i?.url}

Якщо ви цього не очікували, просто проігноруйте цей лист.`)
};

const hi_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} ने आपको Remy Sport पर ${i?.org} में शामिल होने के लिए आमंत्रित किया है।

निमंत्रण स्वीकार करें: ${i?.url}

अगर आपको इसकी उम्मीद नहीं थी, तो इस ईमेल को अनदेखा कर दें।`)
};

const ar_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`دعاك ${i?.invitedBy} للانضمام إلى ${i?.org} على Remy Sport.

اقبل الدعوة: ${i?.url}

إن لم تكن تتوقع هذه الرسالة، فتجاهلها.`)
};

const ms_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} menjemput anda menyertai ${i?.org} di Remy Sport.

Terima jemputan: ${i?.url}

Jika anda tidak menjangkakannya, abaikan sahaja e-mel ini.`)
};

const bn_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} আপনাকে Remy Sport-এ ${i?.org}-এ যোগ দিতে আমন্ত্রণ জানিয়েছেন।

আমন্ত্রণ গ্রহণ করুন: ${i?.url}

এটি প্রত্যাশিত না হলে বার্তাটি উপেক্ষা করুন।`)
};

const zh_tw2_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} 邀請你加入 Remy Sport 上的 ${i?.org}。

接受邀請：${i?.url}

若你並未預期收到這封信，忽略即可。`)
};

const zh_hk2_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} 邀請你加入 Remy Sport 上的 ${i?.org}。

接受邀請：${i?.url}

若你並未預期收到這封信，忽略即可。`)
};

const ur_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} نے آپ کو Remy Sport پر ${i?.org} میں شامل ہونے کی دعوت دی ہے۔

دعوت قبول کریں: ${i?.url}

اگر آپ کو اس کی توقع نہیں تھی تو اس پیغام کو نظر انداز کر دیں۔`)
};

const fa_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} شما را برای پیوستن به ${i?.org} در Remy Sport دعوت کرده است.

پذیرفتن دعوت: ${i?.url}

اگر انتظارش را نداشتید، این پیام را نادیده بگیرید.`)
};

const sw_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} amekualika ujiunge na ${i?.org} kwenye Remy Sport.

Kubali mwaliko: ${i?.url}

Kama hukutegemea hili, puuza barua pepe hii.`)
};

const nl_email_invite_body = /** @type {(inputs: Email_Invite_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} nodigt je uit om lid te worden van ${i?.org} op Remy Sport.

Uitnodiging aannemen: ${i?.url}

Als je dit niet verwachtte, negeer dit bericht dan.`)
};

/**
* | output |
* | --- |
* | "{invitedBy} has invited you to join {org} on Remy Sport. Accept the invitation: {url} If you were not expecting this, you can ignore this email." |
*
* @param {Email_Invite_BodyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const email_invite_body = /** @type {((inputs: Email_Invite_BodyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Invite_BodyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_email_invite_body(inputs)
	if (locale === "ja") return ja_email_invite_body(inputs)
	if (locale === "zh") return zh_email_invite_body(inputs)
	if (locale === "es") return es_email_invite_body(inputs)
	if (locale === "pt") return pt_email_invite_body(inputs)
	if (locale === "id") return id_email_invite_body(inputs)
	if (locale === "fr") return fr_email_invite_body(inputs)
	if (locale === "tl") return tl_email_invite_body(inputs)
	if (locale === "vi") return vi_email_invite_body(inputs)
	if (locale === "ko") return ko_email_invite_body(inputs)
	if (locale === "de") return de_email_invite_body(inputs)
	if (locale === "ru") return ru_email_invite_body(inputs)
	if (locale === "tr") return tr_email_invite_body(inputs)
	if (locale === "it") return it_email_invite_body(inputs)
	if (locale === "pl") return pl_email_invite_body(inputs)
	if (locale === "uk") return uk_email_invite_body(inputs)
	if (locale === "hi") return hi_email_invite_body(inputs)
	if (locale === "ar") return ar_email_invite_body(inputs)
	if (locale === "ms") return ms_email_invite_body(inputs)
	if (locale === "bn") return bn_email_invite_body(inputs)
	if (locale === "zh-TW") return zh_tw2_email_invite_body(inputs)
	if (locale === "zh-HK") return zh_hk2_email_invite_body(inputs)
	if (locale === "ur") return ur_email_invite_body(inputs)
	if (locale === "fa") return fa_email_invite_body(inputs)
	if (locale === "sw") return sw_email_invite_body(inputs)
	if (locale === "nl") return nl_email_invite_body(inputs)
	return en_email_invite_body(inputs)
});